var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardTopbarCrashsightquestLogoWhite = function SvgNewcsDashboardTopbarCrashsightquestLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_topbar_crashsightquest_logo_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_dashboard_topbar_crashsightquest_logo_white_svg__b)",
    d: "M20 0H4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_dashboard_topbar_crashsightquest_logo_white_svg__c)",
    d: "M15 9.03c-3.2-1.2-5.62.35-6.92 1.59l3.23-5.6a.789.789 0 0 1 1.37 0l1.29 2.24L15 9.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_dashboard_topbar_crashsightquest_logo_white_svg__d)",
    d: "m20.29 18.19-1.58-2.74-2.3-3.98c-.21-.25-.44-.49-.68-.7-.83-.7-1.82-1.18-2.89-1.36-.31-.05-.63-.08-.96-.08s-.63.03-.93.07c-.04 0-.08.01-.12.02-1.08.2-2.06.69-2.88 1.41l-4.24 7.34c-.3.53.08 1.19.68 1.19h5.46c.19 0 .35-.14.38-.32 0 0 .41-2.15.42-2.26.07-.74.48-1.32 1.35-1.32s1.35.66 1.35 1.32c.01.11.42 2.25.42 2.25.03.19.19.34.39.34h5.44c.61 0 .99-.66.69-1.19zm-7.3-6c1.09 1.44-.53 3.06-1.97 1.97-1.09-1.44.53-3.06 1.97-1.97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_dashboard_topbar_crashsightquest_logo_white_svg__b",
    x1: 0.38,
    x2: 23.81,
    y1: 1.87,
    y2: 22.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_dashboard_topbar_crashsightquest_logo_white_svg__c",
    x1: 9.53,
    x2: 21.73,
    y1: 7.04,
    y2: 17.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6669FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9187EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A452DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_dashboard_topbar_crashsightquest_logo_white_svg__d",
    x1: 4.26,
    x2: 17.72,
    y1: 10.14,
    y2: 21.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6669FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9187EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A452DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_topbar_crashsightquest_logo_white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNewcsDashboardTopbarCrashsightquestLogoWhite;